<template>
  <div class="productDetailBox">
    <div class="head_top">
      <div class="product_title">
        <div class="right_img">
          <img
            class="productNameImg"
            :src="productData.appLogoUrl"
            alt=""
          />
        </div>
        <p class="productName">{{ productData.productName }}</p>
      </div>
      <ul class="product_use">
        <li>
          <p class="maxAmount"><span style="font-size:8px">¥</span>{{ productData.maxAmount }}</p>
          <p class="font_color">最高额度(万元)</p>
        </li>
        <span class="line"></span>
        <li>
          <p class="rate">{{ productData.rate }}
            <span class="rateunit">%</span>
            </p>
          <p class="font_color">最低{{changeRate}}<span v-if="productData.rateDesc" style="font-size: 10px;">({{productData.rateDesc}})</span></p>
        </li>
        <span class="line"></span>
        <li>
          <p class="font_size">
            <span
              class="repayTerm"
              style="margin-right: 4px"
            >{{
              productData.repayTerm
            }}</span><span>个月</span>
          </p>
          <p class="font_color">借款期限</p>
        </li>
      </ul>
      <ul
        class="the_label"
        v-if="repayTypeArr.length > 0"
      >
        <li
          v-for="(item, index) in repayTypeArr"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <van-tabs
      v-model="active"
      class="tabsListBox"
      scrollspy
      sticky
    >
      <van-tab
        v-for="(e) in tabsList"
        :key="e"
        :title="e"
      >
        <div
          class="condition"
          v-if="e === '申请条件'"
        >
          <div class="condition_count">
            <span></span>
            <p>申请条件</p>
          </div>
          <div
            class="this_text requirements"
            v-html="productData.requirements"
          ></div>
        </div>
        <div
          class="condition"
          v-if="e === '资料准备'"
        >
          <div class="condition_count">
            <span></span>
            <p>资料准备</p>
          </div>
          <div class="this_text">
            <p
              class="preparation"
              v-html="productData.preparation"
            ></p>
          </div>
        </div>
        <div
          class="condition"
          v-if="e === '开放城市'"
        >
          <div class="condition_count">
            <span></span>
            <p>开放城市</p>
          </div>
          <div
            class="this_text openCitys"
            v-html="productData.openCity"
          ></div>
        </div>
      </van-tab>
    </van-tabs>
    <div
      class="condition applyConditionc"
      v-if="!!productData.pdfUrl"
    >
      <div class="condition_count">
        <span></span>
        <p>申请流程</p>
      </div>
      <a
        class="applyButton this_text"
        :href="productData.pdfUrl"
      >查看产品操作手册</a>
    </div>
    <div class="openCity">
      <div
        class="immediately"
        @click="canApply"
      >立即申请</div>
    </div>
    <div
      class="loadingBox"
      v-if="IsloadingBox"
    >
      <Loading
        accountFont="数据请求中，请稍后..."
        size="120"
        color="#eee"
        type="spinner"
      >数据请求中，请稍后...</Loading>
    </div>
    
    <!-- 弹框 -->
    <Notification
      v-if="show"
      :isShow="show"
    ></Notification>
  </div>
</template>
<script>
import { addressIphone } from '@/utils';
import Notification from './components/Notification.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'productDetail',
  data() {
    return {
      show:false,
      productData: {},
      IsloadingBox: false,
      productId: '',
      ShowContent: '',
      repayTypeArr: [],
      orderId: '',
      active: '',
      status: '',
      tabsList: ['申请条件', '资料准备', '开放城市'],
    };
  },
  components: {
    Loading,
    Notification
  },
  mounted() {
    addressIphone();
    this.productId = this.$route.query.productId || '';
    this.getDataList();
  },
  computed: {
    changeRate() {
      const { rateCategory } = this.productData;
      if (rateCategory === '0') return '日利率';
      if (rateCategory === '1') return '月利率';
      if (rateCategory === '2') return '年利率';
      return '日利率';
    },
  },
  methods: {
    getDataList() {
      this.$api.PublicPage.getproductList().then((res) => {
        if (res.success) {
          const item = res.data.list.filter((e) => e.productId === this.productId)[0];
          if(!item){
            return this.show = true
          }
          this.productData = item;
          this.repayTypeArr = item.repayType ? item.repayType.split(',') : [];
        }
      });
    },
    canApply() {
      // sessionStorage.setItem('PRODUCT_ID', this.productId);
      window.location.href = `/backloansuper/loan/supermarket/login2Url/v1.0?k=perfect&productId=${this.productId}`;
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
.productDetailBox {
  padding-bottom: 42px;
}
.head_top {
  width: 100%;
  height: auto;
  background: #fff;
}
.product_title {
  /* width: 345px; */
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  height: 50px;
  /* margin: 0 auto; */
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
.product_title p {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #1c2438;
}
.product_title img {
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 50%;
}
.product_use {
  /* width: 345px; */
  height: 70px;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  /* margin: 0 auto; */
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
}
.product_use li {
  width: 37%;
}
.font_color {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #9e9e9e;
}

.line {
  display: block;
  width: 1px;
  height: 50px;
  background: #f2f2f2;
}
.the_label {
  /* width: 345px; */
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  height: auto;
  /* margin: 0 auto; */
  background: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.the_label li {
  background: #f4f1ec;
  font-family: PingFangSC-Regular;
  font-size: 10px;
  color: #bd895a;
  text-align: center;
  margin: 0 10px 10px 0;
  height: 20px;
  padding: 0 4px 0 4px;
  /*line-height: 20px;*/
  display: flex;
  justify-content: center;
  align-items: center;
}
.condition {
  width: 100%;
  height: auto;
  background: #fff;
}
.condition_count {
  /* width: 345px; */
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  height: 40px;
  /* margin: 0 auto; */
  line-height: 36px;
  display: flex;
}
.condition_count p {
  margin-left: 10px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #1c2438;
}
.condition_count span {
  width: 3px;
  height: 15px;
  background: #ff6538;
  margin-top: 10px;
}
.this_text {
  /* width: 345px; */
  height: auto;
  /* margin: 0 auto; */
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  padding: 3px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #252f49;
  line-height: 20px;
  text-align: left;
}
.applyConditionc {
  text-align: left;
  display: block;
  padding-bottom: 1px;
  margin-bottom: 10px;
  padding-bottom: 15px;
}
.applyButton {
  width: 120px;
  height: 20px;
  line-height: 20px;
  margin-left: 20px;
  margin-bottom: 10px;
  text-align: center;
  color: rgba(235, 64, 40, 95);
  border: 1px solid rgba(235, 64, 40, 95);
  border-radius: 4px;
  padding: 3px 10px !important;
}
.openCity {
  width: 100%;
  height: auto;
}
.immediately {
  width: 100%;
  height: 46px;
  background: #ff6538;
  line-height: 46px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  position: fixed;
  left: 0;
  bottom: 0;
}
.right_img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #eee;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
}
.maxAmount {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #0079cc;
  text-align: left;
  text-align: center;
}
.rate {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #ff6538;
}
.repayTerm {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #242f4b;
  width: 24px;
}
.font_size {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #495060;
}
.img_size {
  width: 15px !important;
}
.WEBANK-FPD {
  width: 30px !important;
}
.this_text {
  width: 100%;
  padding: 9px 15px 20px 15px;
}
.tabsListBox {
  margin-top: 8px;
}
.productDetailBox >>> .van-tab--active {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #1c2438;
}
.productDetailBox >>> .van-tab {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.productDetailBox >>> .van-tabs__line {
  background-color: #ff6538;
}
.rateunit {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #f55646;
}
.productDetailBox >>> .van-tabs--line .van-tabs__wrap {
  border-bottom: 1px solid #eee;
}
</style>
